import { render, staticRenderFns } from "./DashboardIncidents.vue?vue&type=template&id=b955bd4c"
import script from "./DashboardIncidents.vue?vue&type=script&lang=js"
export * from "./DashboardIncidents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports